export const MODULE_NAME = "package";

export const packageStatusMap = {
  active: "Active",
  inActive: "Inactive",
};
